exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".info-block {\n    background-color: #eee;\n    margin: 0 0 20px;\n    padding: 15px;\n}\n.info-block ul li{\n    list-style: none;\n}\n.opener-block{\n    background-color: #eee;\n    margin: 20px 0;\n    padding: 15px;\n}\n\n.info-block input,\n.info-block select {\n    background-color: #fff;\n}\n\nform[name='lead-form'] textarea {\n    resize: none;\n    height: 60px;\n    width: 100%;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/views/leads/import/lead-import.component.css
// module id = 622
// module chunks = 9